import { Outlet } from "react-router";

export function AuthLayout() {
  return (
    <main id="main" tabIndex={-1} className="grid min-h-dvh place-items-center bg-background px-3 py-8">
      <Outlet />
    </main>
  );
}
